(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["active-home-rezultati"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();

    const initSection = (root) => {
      if (!root || cleanups.has(root)) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cleanupTasks = [];
      let observer = null;

      if (!reducedMotion && 'IntersectionObserver' in window) {
        const reveals = Array.from(root.querySelectorAll('.sp-reveal'));
        root.classList.add('sp-motion-ready');

        reveals.forEach((element) => {
          const delay = Math.min(Math.max(Number(element.dataset.delay) || 0, 0), 320);
          element.style.setProperty('--sp-delay', `${delay}ms`);
        });

        let pending = reveals.length;
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            pending -= 1;
            if (pending === 0) observer.disconnect();
          });
        }, { threshold: 0.16, rootMargin: '0px 0px -7% 0px' });

        reveals.forEach((element) => observer.observe(element));
      }

      const canTilt = !reducedMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canTilt) {
        root.querySelectorAll('.sp-card-anchor').forEach((anchor) => {
          const card = anchor.querySelector('.sp-card');
          if (!card) return;

          let frame = 0;
          let rect = null;
          let pointerX = 0;
          let pointerY = 0;

          const renderTilt = () => {
            frame = 0;
            if (!rect) return;
            const normalizedX = (pointerX - rect.left) / rect.width - 0.5;
            const normalizedY = (pointerY - rect.top) / rect.height - 0.5;
            const rotateX = normalizedY * -6;
            const rotateY = normalizedX * 6;
            card.style.transform = `perspective(1100px) translate3d(0, -4px, 0) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`;
          };

          const onEnter = (event) => {
            rect = anchor.getBoundingClientRect();
            pointerX = event.clientX;
            pointerY = event.clientY;
            anchor.classList.add('is-interacting');
            if (!frame) frame = window.requestAnimationFrame(renderTilt);
          };

          const onMove = (event) => {
            pointerX = event.clientX;
            pointerY = event.clientY;
            if (!frame) frame = window.requestAnimationFrame(renderTilt);
          };

          const onLeave = () => {
            if (frame) window.cancelAnimationFrame(frame);
            frame = 0;
            rect = null;
            anchor.classList.remove('is-interacting');
            card.style.removeProperty('transform');
          };

          anchor.addEventListener('pointerenter', onEnter);
          anchor.addEventListener('pointermove', onMove, { passive: true });
          anchor.addEventListener('pointerleave', onLeave);
          cleanupTasks.push(() => {
            if (frame) window.cancelAnimationFrame(frame);
            anchor.removeEventListener('pointerenter', onEnter);
            anchor.removeEventListener('pointermove', onMove);
            anchor.removeEventListener('pointerleave', onLeave);
          });
        });
      }

      cleanups.set(root, () => {
        observer?.disconnect();
        cleanupTasks.forEach((cleanup) => cleanup());
        cleanups.delete(root);
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-sp-section]')) initSection(scope);
      scope.querySelectorAll?.('[data-sp-section]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-sp-section]')
        ? event.target
        : event.target.querySelector?.('[data-sp-section]');
      cleanups.get(root)?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: 0 };
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.scrollFrame = 0;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onScrollHandler = () => {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.onScroll();
        });
      };

      this.setHeaderHeight();
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mediaQuery?.removeEventListener('change', this.onMediaChange);
      this.observer?.disconnect();
      window.clearTimeout(this.isScrolling);

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
      }
    }

    createObserver() {
      this.observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
